import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        chosenPreconditions: '=',
        showPreconditionToggle: '=',
        licence: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.name">
                <label class="label">{{ 'licence.Licence name' | translate }} *</label>
                <div class="items">
                    <input ng-model="vm.form.model.name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.hasPrecondition" ng-if="vm.showPreconditionToggle && vm.form.model.id">
                <label class="label">{{ 'licence.Licence precondition active' | translate }}</label>
                <div class="items">
                    <label class="switch01">
                        <input
                            type="checkbox"
                            ng-model="vm.form.model.hasPrecondition"
                            name="switch"
                            ng-readOnly="vm.licence.hasUpdatedPreconditions"
                            ng-disabled="vm.licence.hasUpdatedPreconditions"
                        >
                        <span>{{ 'general.Yes' | translate }}</span>
                    </label>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.licencePreconditions" ng-if="vm.form.model.id && vm.form.model.hasPrecondition">
                <label class="label">
                    {{ 'licence.Licence precondition' | translate }}<br>
                    <small>{{ 'licence.Employee has to complete only one of the selected courses to fulfill the precondition' | translate }}</small>
                </label>
                <div class="items">
                    <tags-input
                        key-property="id"
                        display-property="name"
                        add-from-autocomplete-only="true"
                        replace-spaces-with-dashes="false"
                        ng-model="vm.chosenPreconditions"
                        placeholder="{{ 'licence.Add precondition' | translate }}"
                        ng-readOnly="vm.licence.hasUpdatedPreconditions"
                        ng-disabled="vm.licence.hasUpdatedPreconditions"
                        >
                        <auto-complete min-length="1" source="vm.loadPreconditions($query)"></auto-complete>
                    </tags-input>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    `
})
export default class {
    constructor (CourseResource) {
        this.CourseResource = CourseResource;
    }

    loadPreconditions (name) {
        return this.CourseResource.query({ name, expand: 'activeI18n' }).$promise.then((response) => {
            return response.map((course) => ({ id: course.id, name: course.activeI18n.name }));
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/form/index.js